import React, { useState, useEffect } from 'react'
import { FormControl, Col, Row, Button, Form } from 'react-bootstrap'
import '../../index.css'

import AlertMessage from '../presentational-components/AlertMessage'

const BaseData = () => {
    const [userName, setUserName] = useState("Test")
    const [email, setEmail] = useState("Test@Mail.de")
    const [password, setPassword] = useState("")
    const [passwordMatch, setPasswordMatch] = useState("")
    const [address, setAddress] = useState("Testhausen 123")

    const [showPasswordValidationError, setShowPasswordValidationError] = useState(false)

    const setBaseData = (baseData) => {
        setUserName(baseData.userName)
        setEmail(baseData.email)
        setAddress(baseData.address)
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        setShowPasswordValidationError(false)

        if (password !== passwordMatch) {
            setShowPasswordValidationError(true)
        }
    }

    const renderBaseData = () => {
        return (
            <div>
                <h1>Stammdatenpflege</h1>
                <br></br>


                <Form onSubmit={handleSubmit}>
                    <Form.Group as={Col} xs="4">
                        <Form.Label className="controlTitle">Benutzername</Form.Label>
                        <Form.Control disabled defaultValue={userName} className="form" as="input" onChange={setUserName}></Form.Control>
                    </Form.Group>

                    <Form.Group as={Col} xs="4">
                        <Form.Label className="controlTitle">E-Mail</Form.Label>
                        <Form.Control disabled defaultValue={email} className="form" as="input" type="email" onChange={setEmail}></Form.Control>
                    </Form.Group>

                    <Form.Row as={Col}>
                        <Form.Group as={Col} xs="4">
                            <Form.Label className="controlTitle">Neues Passwort</Form.Label>
                            <Form.Control className="form" as="input" type="password" onChange={setPassword}></Form.Control>
                            {showPasswordValidationError &&
                                <div className="error">Die eingegebenen Passwörter stimmen nicht überein.</div>}
                        </Form.Group>
                        <Form.Group as={Col} xs="4">
                            <Form.Label className="controlTitle">Passwort erneut eingeben</Form.Label>
                            <Form.Control className="form" as="input" type="password" onChange={setPasswordMatch}></Form.Control>
                        </Form.Group>
                    </Form.Row>

                    <Form.Group as={Col} xs="4">
                        <Form.Label className="controlTitle">Adresse</Form.Label>
                        <Form.Control defaultValue={address} className="form" as="textarea" onChange={setAddress}></Form.Control>
                    </Form.Group>

                    <Button type="submit" variant="secondary">Speichern</Button>
                </Form>

            </div>
        )
    }

    useEffect(() => {
        //FetchBaseData
        //setBaseData()
    }, []);

    return (
        renderBaseData()
    )
}

export default BaseData